import { render, staticRenderFns } from "./SetDetail.vue?vue&type=template&id=2618294f"
import script from "./SetDetail.vue?vue&type=script&lang=js"
export * from "./SetDetail.vue?vue&type=script&lang=js"
import style0 from "./SetDetail.vue?vue&type=style&index=0&id=2618294f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports